import config from '@efdigital/ll-admin-v2/config/environment';
import Component from '@glimmer/component';

interface AdminLegacyWarningSignature {
  Args: {
    item?: { systemLineage?: string; id?: string | null };
    itemType?: string;
    programId?: string | null;
    cohortId?: string | null;
    moduleId?: string | null;
  };
  Element: HTMLDivElement;
}

export default class AdminLegacyWarning extends Component<AdminLegacyWarningSignature> {
  get shouldShow() {
    // If no item is provided, don't show anything
    if (!this.args.item) {
      return false;
    }

    // Show warning if item was created in Admin 1 (no systemLineage or 'll-admin')
    return (
      !this.args.item.systemLineage ||
      this.args.item.systemLineage === 'll-admin'
    );
  }

  get adminV1Url() {
    const baseUrl = config['ll-apps'].adminV1;
    const { item, itemType, programId, cohortId, moduleId } = this.args;

    // Build specific URLs based on item type and available IDs
    if (!item?.id) {
      return baseUrl;
    }

    switch (itemType) {
      case 'cohort':
        return `${baseUrl}/xceed/${programId}/cohort/edit/${item.id}`;
      case 'page':
        if (moduleId) {
          // Module page
          return `${baseUrl}/xceed/${programId}/cohort/${cohortId}/modules/${moduleId}/page/edit/${item.id}`;
        } else {
          // Cohort page
          return `${baseUrl}/xceed/${programId}/cohort/${cohortId}/page/edit/${item.id}`;
        }
      case 'quiz':
        return `${baseUrl}/quiz/edit/${item.id}`;
      default:
        return baseUrl;
    }
  }

  <template>
    {{#if this.shouldShow}}
      <div ...attributes>
        <div
          class="alert alert-warning border-start border-warning border my-4 rounded-4"
          role="alert"
        >
          <div class="d-flex align-items-center gap-3">
            <iconify-icon
              inline
              icon="ph:warning-bold"
              class="text-danger flex-shrink-0 flex-grow-0 fs-1"
            ></iconify-icon>
            <div class="flex-grow-1">
              <strong>Created in Admin 1</strong>
              <p class="mb-0 mt-1">
                This
                {{@itemType}}
                was created using the legacy admin interface. Please
                <a
                  href={{this.adminV1Url}}
                  target="_blank"
                  rel="noopener noreferrer"
                  class="alert-link"
                >
                  <strong>edit it in Admin 1
                    <iconify-icon
                      inline
                      icon="ph:arrow-square-in-bold"
                    /></strong>
                </a>
                to avoid compatibility issues.
              </p>
            </div>
          </div>
        </div>
      </div>
    {{/if}}
  </template>
}
